/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NistCsfWizardCatalogFunctionNodeDto } from './NistCsfWizardCatalogFunctionNodeDto';
import {
    NistCsfWizardCatalogFunctionNodeDtoFromJSON,
    NistCsfWizardCatalogFunctionNodeDtoFromJSONTyped,
    NistCsfWizardCatalogFunctionNodeDtoToJSON,
    NistCsfWizardCatalogFunctionNodeDtoToJSONTyped,
} from './NistCsfWizardCatalogFunctionNodeDto';

/**
 * Nested functions, categories, and slim control rows for the NIST CSF wizard
 * @export
 * @interface NistCsfWizardCatalogTreeResponse
 */
export interface NistCsfWizardCatalogTreeResponse {
    /**
     * Top-level functions in catalog order, each with categories and controls
     * @type {Array<NistCsfWizardCatalogFunctionNodeDto>}
     * @memberof NistCsfWizardCatalogTreeResponse
     */
    functions?: Array<NistCsfWizardCatalogFunctionNodeDto>;
}

/**
 * Check if a given object implements the NistCsfWizardCatalogTreeResponse interface.
 */
export function instanceOfNistCsfWizardCatalogTreeResponse(value: object): value is NistCsfWizardCatalogTreeResponse {
    return true;
}

export function NistCsfWizardCatalogTreeResponseFromJSON(json: any): NistCsfWizardCatalogTreeResponse {
    return NistCsfWizardCatalogTreeResponseFromJSONTyped(json, false);
}

export function NistCsfWizardCatalogTreeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NistCsfWizardCatalogTreeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'functions': json['functions'] == null ? undefined : ((json['functions'] as Array<any>).map(NistCsfWizardCatalogFunctionNodeDtoFromJSON)),
    };
}

export function NistCsfWizardCatalogTreeResponseToJSON(json: any): NistCsfWizardCatalogTreeResponse {
    return NistCsfWizardCatalogTreeResponseToJSONTyped(json, false);
}

export function NistCsfWizardCatalogTreeResponseToJSONTyped(value?: NistCsfWizardCatalogTreeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'functions': value['functions'] == null ? undefined : ((value['functions'] as Array<any>).map(NistCsfWizardCatalogFunctionNodeDtoToJSON)),
    };
}

